import './queries/read';

import { createEntity } from 'lib/resource';
import ShowStatsFollowers from './schema';

export default createEntity(ShowStatsFollowers);
